import { Box, Button, Container, TextField, Typography } from "@mui/material";

export default function CV() {
  return (
    <Container sx={{ py: 6, maxWidth: 720 }}>
      <Typography variant="h4" gutterBottom>CV</Typography>
      <Typography sx={{ mb: 3, opacity: 0.8 }}>
        CV PDF (en cours de peaufinage ⛔🚧)
      </Typography>
    </Container>
  );
}
